import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CookieConsent } from './shared/components/cookie-consent/cookie-consent';
import { AuthService } from './core/services/auth.service';
import { SessionTimeoutService } from './core/services/session-timeout.service';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CookieConsent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly sessionTimeoutService = inject(SessionTimeoutService);

  private readonly isAuthenticated$ = toObservable(this.authService.isAuthenticated);

  public ngOnInit(): void {
    this.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.sessionTimeoutService.startMonitoring();
      } else {
        this.sessionTimeoutService.stopMonitoring();
      }
    });
  }
}
